var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "back-to-outfit gray-bottom-border",
          attrs: { to: _vm.returnPath }
        },
        [
          _c("div", { staticClass: "wtw-container" }, [
            _c("span", { staticClass: "stay-black" }, [
              _vm._v(_vm._s(_vm.returnTitle))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.outfitCurrent
        ? _c(
            "div",
            { staticClass: "purchase-outfit-items-container" },
            _vm._l(_vm.outfitCurrent.products, function(product, index) {
              return _c("purchase-outfit-item", {
                key: product.product_id,
                ref: "product",
                refInFor: true,
                attrs: {
                  product: product,
                  optionChanged: function(option, event) {
                    return _vm.changeProduct(
                      index,
                      _vm.setOption(
                        option,
                        _vm.outfitCurrent.products[index],
                        event
                      )
                    )
                  },
                  toggleProduct: function() {
                    return _vm.toggleOutfitProduct(index)
                  },
                  swapProduct: _vm.setSwapProduct
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wtw-container text-center" }, [
        _c(
          "div",
          {
            staticClass: "button pink full add-items-to-cart",
            class: { disabled: !_vm.anyProductsSelected },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.addProductsToCart.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n            Add Selected Items to Cart\n        ")]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataLoading || !_vm.outfitCurrent,
                expression: "dataLoading || !outfitCurrent"
              }
            ],
            staticClass: "loading-overlay"
          },
          [_c("loader")],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showSwapProduct
            ? _c("swap-item", {
                attrs: { product: _vm.swapProduct, showSizes: true }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8d5a65a", { render: render, staticRenderFns: staticRenderFns })
  }
}